/* braided-wig-try-on: ported from Michelle prototype app.js?v=11 (styles.css?v=12).
   Data: color+length looks from product variants (no cap option).
   Buy adds the look variant directly. Length rows show only when present.
   Theme adaptations: x-modal at document level (moved to body on open), $() fallback,
   delegated clicks on root AND dialogs, AJAX cart/add.js + pubsub cartUpdate.
   Try-On gate: customer login + 10/day quota. One preview per Try-On + optional different
   angle; per-picture regenerate (5 max, quota-free). Prices from live variant.price. */
(function () {
  function initBraidedTryOn(root) {
    var sectionId = root.getAttribute('data-section-id');
    var productId = root.getAttribute('data-product-id');
    var productTitle = root.getAttribute('data-product-title') || '';
    var singleLength = root.getAttribute('data-single-length') === 'true';
    var currency = root.getAttribute('data-currency') || 'USD';
    var memberLoggedIn = root.getAttribute('data-customer-logged-in') === 'true';
    var variantsRaw = JSON.parse(root.getAttribute('data-variants') || '[]');
    var productType = root.getAttribute('data-product-type') || '';
    if (!productType) productType = 'unsupported';
    var isFeather = function () { return productType === 'feather'; };
    root.setAttribute('data-product-type', productType);
    var productImage = root.getAttribute('data-product-image') || '';
    var hairstyles = [];
    try {
      var hsScript = root.querySelector('script[data-bwt-hairstyles]');
      hairstyles = JSON.parse((hsScript && hsScript.textContent) || '[]') || [];
    } catch (e) { hairstyles = []; }
    var productMedia = [];
    try {
      var mediaScript = root.querySelector('script[data-bwt-media]');
      var mediaText = mediaScript ? mediaScript.textContent : (root.getAttribute('data-media') || '[]');
      productMedia = JSON.parse(mediaText || '[]');
    } catch (e) { productMedia = []; }
    var TRYON_API = '/apps/mediacreation/tryon-jobs';
    var TRYON_EVENTS = '/apps/mediacreation/tryon-jobs/events';
    var pendingPhotoFile = null;
    var submittingTryOn = false;
    var pollingBackstop = null;
    var pollingSource = null;
    var historyLoaded = false;

    var money = function (cents) {
      if (cents == null || isNaN(cents)) return '';
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100); }
      catch (e) { return '$' + (cents / 100).toFixed(2); }
    };
    var track = function (action, look) {
      root.dispatchEvent(new CustomEvent('tryon:action', { bubbles: true, detail: { action: action, look: look == null ? null : look, sectionId: sectionId, productId: productId } }));
    };

    var galleryDialog = document.getElementById('BraidedGallery-' + sectionId) || document.querySelector('[id^="BraidedGallery-"]');
    var compareDialogEl = document.getElementById('BraidedCompare-' + sectionId) || document.querySelector('[id^="BraidedCompare-"]');
    var tryOnDialog = document.getElementById('BraidedVirtual-' + sectionId) || document.querySelector('[id^="BraidedVirtual-"]');
    var photoDialog = document.getElementById('BraidedPhoto-' + sectionId) || document.querySelector('[id^="BraidedPhoto-"]');
    var tutorialDialog = document.getElementById('BraidedTutorial-' + sectionId) || document.querySelector('[id^="BraidedTutorial-"]');
    var leaveDialog = document.getElementById('BraidedLeave-' + sectionId) || document.querySelector('[id^="BraidedLeave-"]');
    var capSizeDialog = document.getElementById('BraidedCap-' + sectionId) || document.querySelector('[id^="BraidedCap-"]');
    var allDialogs = [galleryDialog, tryOnDialog, photoDialog, tutorialDialog, leaveDialog, compareDialogEl, capSizeDialog];

    var $ = function (selector) {
      var el = root.querySelector(selector);
      if (el) return el;
      for (var i = 0; i < allDialogs.length; i++) {
        var d = allDialogs[i];
        if (d && d.querySelector) { el = d.querySelector(selector); if (el) return el; }
      }
      return document.querySelector(selector);
    };
    var $$ = function (selector) {
      var out = Array.prototype.slice.call(root.querySelectorAll(selector));
      for (var i = 0; i < allDialogs.length; i++) {
        var d = allDialogs[i];
        if (!d || !d.querySelectorAll) continue;
        Array.prototype.slice.call(d.querySelectorAll(selector)).forEach(function (el) {
          if (out.indexOf(el) === -1) out.push(el);
        });
      }
      return out;
    };
    var isOpen = function (d) { return !!(d && d.hasAttribute('open')); };
    var showDlg = function (d) { if (d && d.show) d.show(); };
    var hideDlg = function (d) { if (d && d.hide) d.hide(); };

    /* new prototype tutorial content: 3 sections, 6 videos */
    var tutorialSections = [
      { name: 'Fast Installation', teaches: 'A quick, secure glueless installation for easy everyday wear and removal.',
        videos: [
          { title: 'Quick Glueless Install', description: 'Put on, position, and secure the wig for an easy everyday fit without adhesive.', cue: 'Align the wig, adjust the built-in band, and confirm that it feels secure and comfortable.' }
        ] },
      { name: 'Lace Spray & Pro Installation', teaches: 'A polished installation with a natural-looking hairline, customized baby hair, and a refined finish.',
        videos: [
          { title: 'Put On the Wig', description: 'Position the wig, align the center part, before applying lace spray.', cue: 'Center the wig first, then check the fit around the hairline and ears.' },
          { title: 'Melt the Hairline', description: 'Apply lace spray in light layers and press the lace into place for a clean, natural-looking hairline.', cue: 'Use light, even layers and allow each layer to become tacky before pressing down the lace.' },
          { title: 'Style the Baby Hair', description: 'Separate, trim, and shape the baby hair to soften and customize the front of the wig.', cue: 'Work with small sections and trim gradually so the baby hair stays soft and natural-looking.' },
          { title: 'Finish the Style', description: 'Set the hairline, arrange the braids and curls, and check the fit for a polished final look.', cue: 'Make the final adjustments only after the lace and baby hair are fully set.' }
        ] },
      { name: 'Style Suggestions', teaches: 'Several ways to wear the wig while keeping the installation secure and natural-looking.',
        videos: [
          { title: 'Ways to Style Your Wig', description: 'See different looks this wig can achieve, from effortless everyday styles to ponytails and updos.', cue: 'Choose styles that feel comfortable and avoid pulling too tightly around the hairline.' }
        ] }
    ];

    /* feather: one look per custom.hairstyle entry with non-empty title; wig: group variants by color+length+pack */
    var looks = [];
    var hsText = function (v) {
      if (v == null) return '';
      if (typeof v === 'string') return v;
      if (typeof v === 'object') return String(v.value != null ? v.value : '');
      return String(v);
    };
    var hasHairstyleTitle = function (h) { return Boolean(hsText(h && h.title).trim()); };
    if (isFeather()) {
      hairstyles.forEach(function (h, hi) {
        if (!hasHairstyleTitle(h)) return;
        var photos = (h && h.photos) || [];
        var fphotos = (h && h.foundationPhotos) || [];
        var first = photos[0] || fphotos[0] || {};
        looks.push({
          key: 'hs-' + hi, hsIndex: hi,
          title: hsText(h.title).trim(),
          short: (h && h.short) || '',
          base: (h && h.foundation) || '',
          method: '',
          packs: (h && h.pack != null && String(h.pack).trim() !== '') ? String(h.pack).trim() : '',
          packQty: (h && h.pack_qty != null && String(h.pack_qty).trim() !== '') ? String(h.pack_qty).trim() : '',
          packUnit: (h && h.pack_unit != null && String(h.pack_unit).trim() !== '') ? String(h.pack_unit).trim() : '',
          materialVariantId: (h && h.material_variant_id != null) ? h.material_variant_id : null,
          price: (h && h.material_price != null && !isNaN(Number(h.material_price))) ? Number(h.material_price) : null,
          variantId: (h && h.material_variant_id != null) ? h.material_variant_id : null,
          photos: photos, foundationPhotos: fphotos,
          variants: []
        });
      });
    }
    var validDims = function (v) {
      var dims = (v && v.dims) || [];
      return dims.filter(function (d) { return d && d.value != null && String(d.value) !== ''; });
    };
    var dimKey = function (v) {
      var dims = validDims(v);
      if (dims.length) return dims.map(function (d) { return String(d.value || ''); }).join('|');
      return (v.color || '') + '|' + (v.length || '') + '|' + (v.density || '');
    };
    var dimTitle = function (v) {
      var dims = validDims(v);
      if (dims.length) return dims.map(function (d) { return String(d.value || ''); }).join(' · ');
      return (v.color || '') + (v.density ? ' · ' + v.density : '') + ' · ' + lenLabel(v.length);
    };
    var lookKey = {};
    variantsRaw.forEach(function (v) {
      if (isFeather()) return;
      var key = dimKey(v);
      if (!lookKey[key]) {
        lookKey[key] = {
          key: key, color: v.color, length: v.length, density: (v.density || ''), dims: (v.dims || []), packs: '', sku: v.sku,
          price: v.price, image: v.image, variantId: v.id,
          title: dimTitle(v),
          variants: []
        };
        looks.push(lookKey[key]);
      }
      var look = lookKey[key];
      look.variants.push(v);
      if (v.image && !look.image) look.image = v.image;
      if (v.price != null && (look.price == null || v.price < look.price)) { look.price = v.price; look.variantId = v.id; }
    });

    /* 配额已临时关闭：上限放大以解开前端门控，后端 quota.ts 同步默认放行；上线恢复 10 即回。 */
    var TRY_ON_LIMIT = 1000000;
    var QUOTA_COPY_ON = false;
    var aiNoticeDismissed = false;
    var countKey = 'jaliza-braided-vto-daily-' + productId + '-v1';
    var packFilter = 'all';
    var lengthFilter = 'all';
    var colorFilter = 'all';
    var comparedLooks = [];
    var comparisonPhotoIndices = [0, 0];
    var galleryPhoto = 0;
    var currentIndex = 0;
    var galleryIndex = 0;
    var tutorialIndex = 0;
    var tutorialVideoIndex = 0;
    var uploadedPhotoUrl = '';
    var elapsedTimer, toastTimer;
    var leaveReminderShown = false;
    var history = [];
    var activeHistoryId = '';
    var enlargedResultKind = 'front';


    function lookImage(look) {
      if (look && look.image) return look.image;
      if (look && look.photos && look.photos[0] && look.photos[0].src) return look.photos[0].src;
      return productImage;
    }
    function normText(s) { return String(s == null ? '' : s).toLowerCase(); }
    function colorTokens(color) {
      return normText(color).split(/[^a-z0-9]+/).filter(function (t) { return t; });
    }
    function colorAliasTokens(color) {
      var c = normText(color);
      var out = [c];
      var m613 = /(^|[^0-9])613([^0-9]|$)/.test(c) || c.indexOf('613') !== -1;
      if (m613) {
        out.push('4/613');
        out.push('#4/613');
        out.push('piano');
      }
      if (c.indexOf('1b/27') !== -1 || (c.indexOf('honey') !== -1 && c.indexOf('blond') !== -1)) {
        out.push('honey blond');
        out.push('honeyblond');
      }
      if (c.indexOf('blend blond') !== -1 || c.indexOf('1b-4&27') !== -1 || c.indexOf('1b-4/27') !== -1) {
        out.push('1b-4&27');
        out.push('1b-4/27');
        out.push('blend blond');
      }
      if (c.indexOf('blend brown') !== -1 || c.indexOf('4&30') !== -1 || c.indexOf('4/30') !== -1) {
        out.push('4&30');
        out.push('4/30');
        out.push('blend brown');
      }
      return out;
    }
    function altMatchesColor(lower, color) {
      if (!color) return true;
      var c = normText(color).trim();
      if (!c) return true;
      if (lower.indexOf(c) !== -1) return true;
      /* alias: alt text may spell blended colors differently from variant names */
      var aliases = colorAliasTokens(color);
      for (var ai = 0; ai < aliases.length; ai++) {
        var alias = aliases[ai];
        if (alias && alias !== c && lower.indexOf(alias) !== -1) return true;
      }
      var toks = colorTokens(color);
      if (!toks.length) return true;
      /* ombre browns: alt spells 1B-30 as 4-30-27 (drops brown/1b), so match ombre + number */
      if (c.indexOf('ombre') !== -1 && c.indexOf('brown') !== -1) {
        var nums = toks.filter(function (t) { return /^[0-9]+$/.test(t); });
        if (lower.indexOf('ombre') !== -1 && nums.every(function (n) { return lower.indexOf(n) !== -1; })) return true;
      }
      /* strict: every significant token must appear; numeric tokens (30, 27, 4) match as substrings since alt writes 1B-30 as 4-30-27 */
      for (var i = 0; i < toks.length; i++) {
        var tok = toks[i];
        if (tok.length < 2) continue;
        if (lower.indexOf(tok) === -1) return false;
      }
      return true;
    }
    function altMatchesLength(lower, length) {
      var len = normLen(length);
      if (!len) return true;
      var m = String(len).match(/[\d.]+/);
      if (!m) return true;
      var num = m[0].replace('.', '\\.');
      try { return new RegExp('(^|[^0-9])' + num + '([^0-9]|$)').test(lower); } catch (e) { return lower.indexOf(m[0]) !== -1; }
    }
    function isMannequinFrontAlt(lower) {
      return lower.indexOf('mannequin - front view') !== -1 || lower.indexOf('mannequin-front view') !== -1;
    }
    function isFrontAlt(lower) {
      return lower.indexOf('\u6b63\u9762') !== -1 || lower.indexOf('front') !== -1;
    }
    /* SPU length fallback: single-length products carry length in title (e.g. Kiki 16"), use it for photo filtering. */
    var spuLen = (function () {
      var m = String(productTitle || '').match(/([\d.]+)\s*(?:inch|in|″|")/i);
      return m ? m[1] + '\u2033' : '';
    })();
    /* wig: color-only match when product has no length option; otherwise color+length.
       Single-length edge: title length still applies so one color does not pull all lengths. */
    function wigMatchedImages(look) {
      var out = [];
      if (!look || isFeather()) return out;
      for (var mi = 0; mi < productMedia.length; mi++) {
        var item = productMedia[mi] || {};
        var alt = String(item.alt || '');
        var lower = normText(alt);
        if (!item.src || !lower) continue;
        if (!altMatchesColor(lower, look.color)) continue;
        if (!singleLength) {
          if (!altMatchesLength(lower, look.length)) continue;
        } else if (spuLen) {
          if (!altMatchesLength(lower, spuLen)) continue;
        }
        out.push({ src: item.src, alt: alt });
      }
      return out;
    }
    /* No matched wig photo: try-on entry disabled with toast, no upload. */
    function tryOnAvailability(look) {
      var wig = look ? wigReferenceImage(look) : { src: '' };
      return { ok: Boolean(wig.src), wig: wig };
    }
    /* feather: metafield hairstyle photo; wig: SKU main image first, matched color+length alt front as fallback. */
    function wigReferenceImage(look) {
      if (!look) return { src: '', alt: '' };
      if (isFeather() && look.photos && look.photos[0] && look.photos[0].src) {
        return { src: look.photos[0].src, alt: look.photos[0].alt || look.title };
      }
      var main = skuMainImage(look);
      if (main) return { src: main, alt: look.title };
      var matched = wigMatchedImages(look);
      if (!matched.length) return { src: '', alt: '' };
      var mannequinFront = null;
      var front = null;
      for (var i = 0; i < matched.length; i++) {
        var lower = normText(matched[i].alt);
        if (!mannequinFront && isMannequinFrontAlt(lower)) mannequinFront = matched[i];
        if (!front && isFrontAlt(lower)) front = matched[i];
      }
      return mannequinFront || front || matched[0];
    }
    function availableLengthsForColor(color) {
      var out = [];
      try {
        for (var ai = 0; ai < productMedia.length; ai++) {
          var aa = String((productMedia[ai] && productMedia[ai].alt) || '');
          var al = normText(aa);
          if (altMatchesColor(al, color)) {
            var lm = al.match(/(\d+(?:\.\d+)?)\s*(?:inch|in|″|")/);
            var lv = lm ? lm[1] + '″' : '';
            if (lv && out.indexOf(lv) === -1) out.push(lv);
          }
        }
      } catch (e2) {}
      out.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
      return out;
    }
    function todayKey() {
      var d = new Date();
      return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
    }
    function getCount() {
      try {
        var r = JSON.parse(localStorage.getItem(countKey) || 'null');
        return r && r.date === todayKey() ? Math.min(Number(r.count) || 0, TRY_ON_LIMIT) : 0;
      } catch (e) { return 0; }
    }
    function setCount(c) { try { localStorage.setItem(countKey, JSON.stringify({ date: todayKey(), count: c })); } catch (e) {} }
    function remaining() { return Math.max(TRY_ON_LIMIT - getCount(), 0); }
    function capLabel(look) {
      if (!look || !look.variants || !look.variants.length) return 'One size';
      var caps = [];
      look.variants.forEach(function (v) {
        var c = v && v.cap ? String(v.cap) : '';
        if (c && caps.indexOf(c) === -1) caps.push(c);
      });
      if (!caps.length) return 'One size';
      return caps.join(' / ');
    }
    function lookHasCap(look) {
      var vs = (look && look.variants) || [];
      for (var i = 0; i < vs.length; i++) {
        var c = vs[i] && vs[i].cap ? String(vs[i].cap).trim() : '';
        if (c) return true;
      }
      return false;
    }
    function dimName(name) {
      var n = String(name == null ? '' : name).toLowerCase();
      if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1 || n.indexOf('shade') !== -1) return 'Color';
      if (n.indexOf('length') !== -1 || n.indexOf('inch') !== -1) return 'Length';
      if (n.indexOf('density') !== -1) return 'Density';
      return String(name == null ? '' : name);
    }
    function dimRows(look) {
      var dims = validDims(look);
      if (dims.length) {
        return dims.filter(function (d) { return d && d.value; }).map(function (d) {
          return '<li><span>' + esc(dimName(d.name)) + ':</span><span>' + esc(d.value) + '</span></li>';
        }).join('');
      }
      return '<li><span>Color:</span><span>' + esc(look.color) + '</span></li>' +
        (look.density ? '<li><span>Density:</span><span>' + esc(look.density) + '</span></li>' : '') +
        (lookHasLength(look) ? '<li><span>Length:</span><span>' + esc(lenLabel(look.length)) + '</span></li>' : '');
    }
    function currentLook() { return looks[currentIndex]; }

    function showToast(message) {
      var toast = $('[data-bwt="toast"]');
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2400);
    }

    function clearTryOnTimers() {
      stopPolling();
      clearInterval(elapsedTimer);
      submittingTryOn = false;
      var activeEntry = null;
      history.forEach(function (item) { if (item.id === activeHistoryId) activeEntry = item; });
      if (activeEntry) activeEntry.regeneratingView = '';
      $$('[data-regenerating-view]').forEach(function (overlay) { overlay.hidden = true; });
      $$('[data-regenerate-result]').forEach(function (button) {
        if (button.classList.contains('secondary')) button.textContent = 'Regenerate this picture';
        else button.innerHTML = '<span aria-hidden="true">↻</span> Regenerate';
        button.disabled = false;
      });
    }

    /* filters */
    function normLen(raw) {
      var m = String(raw == null ? '' : raw).match(/[\d.]+/);
      return m ? m[0] : String(raw == null ? '' : raw);
    }
    function lenLabel(raw) { return normLen(raw) + '\u2033'; }
    function sameLen(a, b) { return normLen(a) === normLen(b); }
    function lookHasLength(look) {
      if (singleLength) return false;
      return Boolean(String(look && look.length != null ? look.length : '').match(/[\d.]+/));
    }
    function packNum(v) {
      var raw = v && (v.pack != null ? v.pack : v.packs);
      var m = raw == null || raw === '' ? null : String(raw).match(/[\d.]+/);
      if (m) return m[0];
      var shortText = hsText(v && v.short);
      var sm = shortText ? shortText.match(/(\d+(?:\.\d+)?)\s*packs?/i) : null;
      return sm ? sm[1] : '';
    }
    function lookPacks(look) {
      if (look && look.packs) return String(look.packs);
      return packNum(look) || 'all';
    }
    function packLabel(look) {
      var q = look && look.packQty != null ? String(look.packQty).trim() : '';
      var u = look && look.packUnit != null ? String(look.packUnit).trim() : '';
      if (q) return u ? (q + ' ' + u.toLowerCase()) : (q + ' packs');
      var n = lookPacks(look);
      return n && n !== 'all' ? (n + ' packs') : '';
    }
    function buildWigFilters() {
      var lengths = [], colors = [];
      looks.forEach(function (l) {
        if (!skuMainImage(l)) return;
        if (!singleLength && lookHasLength(l) && lengths.every(function (x) { return !sameLen(x, l.length); })) lengths.push(normLen(l.length));
        if (l.color && colors.indexOf(l.color) === -1) colors.push(l.color);
      });
      lengths.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
      var lf = $('[data-bwt="lengthFilters"]');
      if (lf) lf.hidden = lengths.length <= 1;
      if (lf) {
        lf.querySelectorAll('[data-length-filter]').forEach(function (b) { if (b.dataset.lengthFilter !== 'all') b.remove(); });
        lengths.forEach(function (len) {
          var b = document.createElement('button');
          b.type = 'button'; b.dataset.lengthFilter = len;
          b.setAttribute('aria-pressed', 'false');
          b.textContent = len + '\u2033';
          b.addEventListener('click', function () {
            lengthFilter = len;
            lf.querySelectorAll('[data-length-filter]').forEach(function (item) {
              var a = item === b;
              item.classList.toggle('active', a);
              item.setAttribute('aria-pressed', String(a));
            });
            renderCards();
            track('filter', null);
          });
          lf.appendChild(b);
        });
        var allBtn = lf.querySelector('[data-length-filter="all"]');
        if (allBtn && !allBtn.getAttribute('data-wig-all-bound')) {
          allBtn.setAttribute('data-wig-all-bound', '1');
          allBtn.addEventListener('click', function () {
            lengthFilter = 'all';
            lf.querySelectorAll('[data-length-filter]').forEach(function (item) {
              var a = item === allBtn;
              item.classList.toggle('active', a);
              item.setAttribute('aria-pressed', String(a));
            });
            renderCards();
            track('filter', null);
          });
        }
      }
      var cf = $('[data-bwt="colorFilter"]');
      if (cf) {
        cf.querySelectorAll('option').forEach(function (o) { if (o.value !== 'all') o.remove(); });
        colors.forEach(function (c) {
          var o = document.createElement('option');
          o.value = c; o.textContent = c;
          cf.appendChild(o);
        });
      }
    }
    function syncFilterVisibility() {
      var feather = isFeather();
      var wf = $('[data-bwt="wigFilters"]');
      if (wf) {
        if (feather) wf.hidden = true;
        else {
          var dims = 0;
          var seenL = [], seenC = [];
          looks.forEach(function (l) {
            if (!skuMainImage(l)) return;
            if (!singleLength && lookHasLength(l) && seenL.every(function (x) { return !sameLen(x, l.length); })) seenL.push(l.length);
            if (l.color && seenC.indexOf(l.color) === -1) seenC.push(l.color);
          });
          if (seenL.length > 1) dims++;
          if (seenC.length > 1) dims++;
          wf.hidden = dims <= 1;
        }
      }
      var pf = $('[data-bwt="packFilters"]');
      if (pf) pf.hidden = !feather;
      var nl = $('[data-bwt="noLooks"]');
      if (nl) nl.textContent = feather ? 'No finished looks are available for this pack quantity yet.' : 'No looks match these filters.';
    }
    function buildFilters() {
      syncFilterVisibility();
      if (!isFeather()) { buildWigFilters(); return; }
      var packs = [];
      looks.forEach(function (l) {
        var p = lookPacks(l);
        if (!p || p === 'all') return;
        if (packs.indexOf(p) === -1) packs.push(p);
      });
      packs.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
      var lf = $('[data-bwt="packFilters"]');
      if (lf) {
        lf.querySelectorAll('[data-pack-filter]').forEach(function (b) { if (b.dataset.packFilter !== 'all') b.remove(); });
        packs.forEach(function (p) {
          var b = document.createElement('button');
          b.type = 'button'; b.dataset.packFilter = p;
          b.setAttribute('aria-pressed', 'false');
          var _pl = looks.filter(function (x) { return lookPacks(x) === p; })[0];
          b.textContent = _pl ? (packLabel(_pl) || (p + ' packs')) : (p + ' packs');
          b.addEventListener('click', function () {
            packFilter = p;
            lf.querySelectorAll('[data-pack-filter]').forEach(function (item) {
              var a = item === b;
              item.classList.toggle('active', a);
              item.setAttribute('aria-pressed', String(a));
            });
            renderCards();
            track('filter', null);
          });
          lf.appendChild(b);
        });
        if (!lf.querySelector('[data-pack-all-bound]')) {
          lf.setAttribute('data-pack-all-bound', '1');
          var allBtn = lf.querySelector('[data-pack-filter="all"]');
          if (allBtn) allBtn.addEventListener('click', function () {
            packFilter = 'all';
            lf.querySelectorAll('[data-pack-filter]').forEach(function (item) {
              var a = item === allBtn;
              item.classList.toggle('active', a);
              item.setAttribute('aria-pressed', String(a));
            });
            renderCards();
            track('filter', null);
          });
        }
      }
    }

    function esc(s) {
      if (s != null && typeof s === 'object') s = s.value != null ? s.value : '';
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function lookBase(look) {
      if (look && look.base) return look.base;
      if (isFeather()) return '';
      if (look && (look.color || look.length)) return ((look.color || '') + ' · ' + lenLabel(look.length)).trim();
      return '';
    }
    function skuMainImage(look) {
      if (!look) return '';
      if (look.image) return look.image;
      if (look.variants) {
        for (var i = 0; i < look.variants.length; i++) {
          if (look.variants[i] && look.variants[i].image) return look.variants[i].image;
        }
      }
      return '';
    }
    function lookGalleryItems(look) {
      if (isFeather() && look && (look.photos || look.foundationPhotos)) {
        var out = [];
        (look.photos || []).forEach(function (ph, i) {
          if (ph && ph.src) out.push({ src: ph.src, type: 'look', label: 'Finished look ' + (i + 1) });
        });
        (look.foundationPhotos || []).forEach(function (ph) {
          if (ph && ph.src) out.push({ src: ph.src, type: 'foundation', label: 'Foundation front' });
        });
        if (out.length) return out;
      }
      /* wig gallery: SKU main image first, then all color+length matched alt images for compare */
      var out = [];
      var seen = {};
      var pushUnique = function (src, alt, label) {
        if (!src || seen[src]) return;
        seen[src] = true;
        out.push({ src: src, alt: alt || '', type: 'look', label: label || ('Finished look ' + (out.length + 1)) });
      };
      pushUnique(skuMainImage(look), '', 'SKU main image');
      var matched = wigMatchedImages(look);
      matched.slice().sort(function (a, b) {
        var score = function (m) {
          var l = normText(m.alt);
          if (isMannequinFrontAlt(l)) return 0;
          if (isFrontAlt(l)) return 1;
          return 2;
        };
        return score(a) - score(b);
      }).forEach(function (m) {
        pushUnique(m.src, m.alt);
      });
      if (!out.length) {
        var fb = lookImage(look);
        if (fb) pushUnique(fb, '', 'Finished look 1');
      }
      out.forEach(function (it, i) { it.label = i === 0 ? 'SKU main image' : ('Finished look ' + (i + 1)); });
      return out;
    }
    function lookFoundationPhoto(look) {
      if (isFeather() && look && look.foundationPhotos && look.foundationPhotos[0]) return look.foundationPhotos[0].src || '';
      var wig = look ? wigReferenceImage(look) : { src: '' };
      return wig.src || '';
    }
    function lookVisible(v) {
      if (isFeather()) return packFilter === 'all' || lookPacks(v) === packFilter;
      if (!skuMainImage(v)) return false;
      var lenOk = singleLength || lengthFilter === 'all' || sameLen(v.length, lengthFilter) || !lookHasLength(v);
      return lenOk && (colorFilter === 'all' || v.color === colorFilter);
    }
    function renderCards() {
      syncFilterVisibility();
      var visible = looks.filter(lookVisible);
      /* empty gallery: hide the whole module (single-sku / no-image products) */
      var hasCards = visible.some(function (v) {
        if (isFeather()) return true;
        return Boolean(skuMainImage(v));
      });
      if (!hasCards) {
        root.hidden = true;
        track('gallery_empty_hide', null);
        return;
      }
      if (productType === 'unsupported') {
        root.hidden = true;
        return;
      }
      root.hidden = false;
      var cmp = $('[data-bwt="lookComparison"]');
      if (cmp) cmp.hidden = false;
      var carousel = $('[data-bwt="lookCarousel"]');
      if (!carousel) return;
      carousel.innerHTML = visible.map(function (v) {
        var idx = looks.indexOf(v);
        var selected = comparedLooks.indexOf(idx) !== -1;
        if (!isFeather()) {
          var cardImg = skuMainImage(v) || '';
          if (!cardImg) return '';
          return '<article class="look-card" data-index="' + idx + '">' +
            '<button class="look-image" type="button" data-gallery="' + idx + '" data-gallery-photo="0" aria-label="View ' + esc(v.title) + '">' +
            (cardImg ? '<img src="' + esc(cardImg) + '" alt="' + esc(v.title) + '" loading="lazy" />' : '') +
            '</button>' +
            '<div class="look-copy">' +
            '<ul class="look-specs" aria-label="Wig specifications">' +
            dimRows(v) +
            '<dl><div><dt>Starting price</dt><dd>' + esc(money(v.price)) + '</dd></div></dl>' +
            '<button class="look-compare' + (selected ? ' selected' : '') + '" type="button" data-compare-look="' + idx + '" aria-pressed="' + (selected ? 'true' : 'false') + '">' + (selected ? 'Selected for comparison ✓' : 'Compare') + '</button>' +
            '<div class="look-actions"><button type="button" data-try-on="' + idx + '"' + (tryOnAvailability(v).ok ? '' : ' disabled aria-disabled="true" title="Not available for try-on"') + '>' + (tryOnAvailability(v).ok ? 'Try it on' : 'Not available for try-on') + '</button>' +
            '<button class="watch" type="button" data-tutorial="' + idx + '">How to Install</button></div>' +
            (lookHasCap(v) ? '<button class="look-buy" type="button" data-cap-shop="' + idx + '">Choose cap size &amp; add to cart</button>' : '<button class="look-buy" type="button" data-buy="' + idx + '">Add to cart</button>') +
            '</div></article>';
        }
        return '<article class="look-card" data-index="' + idx + '">' +
          '<button class="look-image" type="button" data-gallery="' + idx + '" data-gallery-photo="0" aria-label="View ' + esc(v.title) + ' photos and foundation">' +
          '<img src="' + esc(lookImage(v)) + '" alt="' + esc(hsText(v.title)) + ' hairstyle" loading="lazy" /></button>' +
          '<div class="look-thumbnails" data-card-thumbnails="' + idx + '" aria-label="' + esc(v.title) + ' foundation"></div>' +
            '<div class="look-copy"><strong>' + esc(v.title) + '</strong>' +
          '<button class="look-compare' + (selected ? ' selected' : '') + '" type="button" data-compare-look="' + idx + '" aria-pressed="' + (selected ? 'true' : 'false') + '">' + (selected ? 'Selected for comparison ✓' : 'Compare') + '</button>' +
          '<div class="look-actions"><button type="button" data-try-on="' + idx + '">Try it on</button></div>' +
          '<button class="look-buy" type="button" data-feather-buy="' + idx + '"' + (v.variantId ? '' : ' disabled aria-disabled="true" title="Variant unavailable"') + '>Add to cart · ' + esc(money(v.price)) + '</button>' +
          '</div></article>';
      }).join('');
      renderCardThumbnails();
      renderComparison();
      var nl = $('[data-bwt="noLooks"]');
      if (nl) nl.hidden = visible.length > 0;
    }
    function renderCardThumbnails() {
      $$('[data-card-thumbnails]').forEach(function (holder) {
        var idx = Number(holder.getAttribute('data-card-thumbnails'));
        var look = looks[idx];
        if (!look) { holder.innerHTML = ''; return; }
        var f = lookFoundationPhoto(look);
        var items = lookGalleryItems(look);
        var fIdx = 0;
        for (var i = 0; i < items.length; i++) { if (items[i].type === 'foundation') { fIdx = i; break; } }
        var baseText = lookBase(look);
        if (isFeather() && !baseText) { holder.innerHTML = ''; holder.hidden = true; return; }
        holder.hidden = false;
        holder.innerHTML = '<button type="button" data-gallery="' + idx + '" data-gallery-photo="' + fIdx + '" aria-label="View ' + esc(look.title) + ' foundation">' +
          (f ? '<img src="' + esc(f) + '" alt="' + esc(look.title) + ' foundation map" />' : '') +
          '<span><small>Foundation</small>' + esc(baseText) + '</span></button>';
      });
    }
    function renderComparison() {
      var holder = $('[data-bwt="comparisonGrid"]');
      if (!holder) return;
      var count = $('[data-bwt="comparisonCount"]');
      if (count) count.textContent = comparedLooks.length + '/2 selected';
      var clear = $('[data-bwt="clearComparison"]');
      if (clear) clear.hidden = comparedLooks.length === 0;
      if (!comparedLooks.length) {
        holder.innerHTML = '<p class="comparison-empty">Select <strong>Compare</strong> on 2 hairstyles to open the photo comparison.</p>';
        return;
      }
      holder.innerHTML = comparedLooks.map(function (idx) {
        var look = looks[idx];
        if (!look) return '';
        return '<article class="comparison-selection">' +
          '<button class="comparison-remove" type="button" data-remove-comparison="' + idx + '" aria-label="Remove ' + esc(look.title) + ' from comparison">×</button>' +
          '<img src="' + esc((!isFeather() ? (skuMainImage(look) || lookImage(look)) : lookImage(look))) + '" alt="' + esc(look.title) + ' finished look" />' +
          '<div><strong>' + esc(look.title) + '</strong></div></article>';
      }).join('') + '<button class="comparison-open" type="button" data-open-comparison' + (comparedLooks.length === 2 ? '' : ' disabled') + '>' + (comparedLooks.length === 2 ? 'COMPARE LARGE PHOTOS' : 'SELECT 1 MORE LOOK') + '</button>';
    }
    /* Compare keeps the 2 most recent: a 3rd pick replaces the earliest, no toast. */
    function toggleComparison(idx) {
      idx = Number(idx);
      var at = comparedLooks.indexOf(idx);
      if (at !== -1) comparedLooks.splice(at, 1);
      else {
        comparedLooks.push(idx);
        if (comparedLooks.length > 2) comparedLooks.shift();
      }
      renderCards();
      renderGalleryCompareState();
      if (comparedLooks.length === 2) openComparisonDialog();
    }
    function renderGalleryCompareState() {
      var gCmp = $('[data-bwt="galleryCompare"]');
      if (!gCmp) return;
      var gi = galleryIndex;
      if (gi == null || !looks[gi]) {
        var attr = gCmp.getAttribute('data-gallery-compare');
        gi = attr === '' || attr == null ? NaN : Number(attr);
      }
      var selected = Number.isFinite ? Number.isFinite(gi) && comparedLooks.indexOf(gi) !== -1 : comparedLooks.indexOf(gi) !== -1;
      gCmp.textContent = selected ? 'Selected for comparison \u2713' : 'Compare';
      gCmp.classList.toggle('selected', selected);
      gCmp.setAttribute('aria-pressed', String(selected));
    }
    function renderComparisonDialog() {
      var body = $('[data-bwt="comparisonBody"]');
      if (!body) return;
      body.innerHTML = comparedLooks.map(function (idx, side) {
        var look = looks[idx];
        if (!look) return '';
        var items = lookGalleryItems(look);
        var photoIndex = comparisonPhotoIndices[side] || 0;
        if (photoIndex >= items.length) photoIndex = 0;
        var item = items[photoIndex] || items[0];
        var isF = item.type === 'foundation';
        return '<article class="comparison-look"><figure class="comparison-main' + (isF ? ' foundation' : '') + '">' +
          '<img src="' + esc(item.src) + '" alt="' + esc(look.title + (isF ? ' foundation' : ' finished look ' + (photoIndex + 1))) + '" /></figure>' +
          '<div class="comparison-look-footer"><div class="comparison-thumbnails" aria-label="Choose a ' + esc(look.title) + ' comparison photo">' +
          items.map(function (photo, pi) {
            return '<button class="' + (pi === photoIndex ? 'active' : '') + (photo.type === 'foundation' ? ' foundation' : '') + '" type="button" data-comparison-side="' + side + '" data-comparison-photo="' + pi + '" aria-label="Show ' + esc(look.title + ' ' + photo.label) + '" aria-pressed="' + (pi === photoIndex) + '"><img src="' + esc(photo.src) + '" alt="" /></button>';
          }).join('') + '</div>' +
          '<div class="comparison-specs"><div><small>' + (isFeather() ? 'Hair' : 'Color') + '</small><strong>' + esc(isFeather() ? (packLabel(look) || lookBase(look)) : look.color) + '</strong></div>' + (lookHasLength(look) || isFeather() ? '<div><small>' + (isFeather() ? 'Foundation' : 'Length') + '</small><strong>' + esc(isFeather() ? lookBase(look) : lenLabel(look.length)) + '</strong></div>' : '') + '</div>' +
          '</div></article>';
      }).join('');
    }
    function openComparisonDialog() {
      if (comparedLooks.length !== 2) return;
      comparisonPhotoIndices = [0, 0];
      renderComparisonDialog();
      var d = compareDialogEl;
      if (d && !isOpen(d)) showDlg(d);
    }

    function selectLook(index) {
      currentIndex = Number(index);
      return currentLook();
    }

    /* gallery */
    function renderGallery() {
      var look = looks[galleryIndex];
      if (!look) return;
      var items = lookGalleryItems(look);
      var pi = galleryPhoto || 0;
      if (pi >= items.length) pi = 0;
      galleryPhoto = pi;
      var item = items[pi] || items[0];
      var isF = item.type === 'foundation';
      var packs = lookPacks(look);
      var dt1 = $('[data-bwt="galleryDt1"]');
      var dt2 = $('[data-bwt="galleryDt2"]');
      var dt3 = $('[data-bwt="galleryDt3"]');
      if (isFeather()) {
        if (dt1) dt1.textContent = 'Hair needed';
        if (dt2) dt2.textContent = 'Foundation';
        if (dt3) dt3.textContent = 'Hair kit price';
        $('[data-bwt="galleryDetailTitle"]').textContent = hsText(look.title);
        var gs = $('[data-bwt="galleryShort"]');
        if (gs) {
          var shortText = hsText(look.short);
          gs.textContent = shortText;
          gs.hidden = !shortText.trim();
          if (!shortText.trim() && !look.__shortWarned) {
            look.__shortWarned = true;
            try { console.warn('[braided-tryon] empty short_description', { title: hsText(look.title), raw: look.short }); } catch (e) {}
          }
        }
        var gm = $('[data-bwt="galleryMethod"]');
        if (gm) gm.textContent = '';
        $('[data-bwt="galleryPacks"]').textContent = packLabel(look) || lookBase(look);
        var dt1Row = dt1 && dt1.closest ? dt1.closest('div') : null;
        if (dt1Row) dt1Row.hidden = !$('[data-bwt="galleryPacks"]').textContent.trim();
        $('[data-bwt="galleryBase"]').textContent = lookBase(look);
        var dt2Row = dt2 && dt2.closest ? dt2.closest('div') : null;
        if (dt2Row) dt2Row.hidden = !$('[data-bwt="galleryBase"]').textContent.trim();
        $('[data-bwt="galleryPrice"]').textContent = look.price != null ? money(look.price) : '';
        var dt3Row = dt3 && dt3.closest ? dt3.closest('div') : null;
        if (dt3Row) dt3Row.hidden = look.price == null;
      } else {
        var r1 = dt1 && dt1.closest ? dt1.closest('div') : null;
        if (r1) r1.hidden = false;
        var r2 = dt2 && dt2.closest ? dt2.closest('div') : null;
        if (r2) r2.hidden = false;
        var r3 = dt3 && dt3.closest ? dt3.closest('div') : null;
        if (r3) r3.hidden = false;
        if (dt1) dt1.textContent = 'Color';
        if (dt2) dt2.textContent = 'Length';
        if (dt3) dt3.textContent = 'Starting price';
        $('[data-bwt="galleryDetailTitle"]').textContent = productTitle || look.title;
        var gm2 = $('[data-bwt="galleryMethod"]');
        if (gm2) gm2.textContent = '';
        $('[data-bwt="galleryPacks"]').textContent = look.color;
        $('[data-bwt="galleryBase"]').textContent = lookHasLength(look) ? lenLabel(look.length) : '';
        var gBaseRow = dt2 && dt2.closest ? dt2.closest('div') : null;
        if (gBaseRow) gBaseRow.hidden = !lookHasLength(look);
        $('[data-bwt="galleryPrice"]').textContent = money(look.price);
      }
      var gi = $('[data-bwt="galleryMainImage"]');
      gi.src = item.src; gi.alt = isF ? look.title + ' ' + item.label.toLowerCase() : look.title + ' finished-look image ' + (pi + 1);
      var fig = $('[data-bwt="galleryMainFigure"]');
      if (fig) fig.classList.toggle('foundation', isF);
      var typ = $('[data-bwt="galleryImageType"]');
      if (typ) typ.textContent = isF ? 'Foundation' : 'Finished Look';
      var gTry = $('[data-bwt="galleryTryOn"]');
      if (gTry) {
        var gAv = tryOnAvailability(look).ok;
        gTry.disabled = !gAv;
        gTry.textContent = gAv ? 'Try it on' : 'Not available for try-on';
        gTry.title = gAv ? '' : 'This combination is not available for try-on';
      }
      var gCmp = $('[data-bwt="galleryCompare"]');
      if (gCmp) {
        var gSelected = comparedLooks.indexOf(galleryIndex) !== -1;
        gCmp.textContent = gSelected ? 'Selected for comparison \u2713' : 'Compare';
        gCmp.classList.toggle('selected', gSelected);
        gCmp.setAttribute('aria-pressed', String(gSelected));
        gCmp.setAttribute('data-gallery-compare', String(galleryIndex));
      }
      var gb = $('[data-bwt="galleryCapShop"]');
      if (gb) {
        if (isFeather()) {
          gb.hidden = false;
          gb.textContent = 'Add to cart \u00b7 ' + money(look.price);
          if (gb.tagName === 'A') gb.href = '#';
          gb.setAttribute('data-feather-buy', String(galleryIndex));
          gb.removeAttribute('data-buy');
          gb.toggleAttribute('disabled', !look.variantId);
        } else {
          gb.hidden = false;
          if (gb.tagName === 'A') gb.href = '#';
          gb.removeAttribute('data-feather-buy');
          if (lookHasCap(looks[galleryIndex])) {
            gb.textContent = 'Choose cap size & add to cart';
            gb.setAttribute('data-cap-shop', String(galleryIndex));
            gb.removeAttribute('data-buy');
          } else {
            gb.textContent = 'Add to cart';
            gb.setAttribute('data-buy', String(galleryIndex));
            gb.removeAttribute('data-cap-shop');
          }
          gb.toggleAttribute('disabled', !look.variantId);
        }
      }
      var holder = $('[data-bwt="galleryThumbnails"]');
      if (holder) {
        holder.innerHTML = items.map(function (photo, idx2) {
          return '<button class="' + (idx2 === pi ? 'active' : '') + (photo.type === 'foundation' ? ' foundation' : '') + '" type="button" data-gallery-angle="' + idx2 + '" aria-label="Show ' + esc(photo.label) + '" aria-pressed="' + (idx2 === pi) + '"><img src="' + esc(photo.src) + '" alt="" /></button>';
        }).join('');
      }
    }
    function openGallery(index, photo) {
      galleryIndex = Number(index);
      galleryPhoto = photo == null ? 0 : Number(photo);
      var look = looks[galleryIndex];
      if (!look) return;
      renderGallery();
      showDlg(galleryDialog);
      track('gallery_open', galleryIndex);
    }

    var capFallbackSizes = [
      { code: 'XS', measure: '19.5″' },
      { code: 'S', measure: '21.25″' },
      { code: 'M', measure: '22″' },
      { code: 'L', measure: '22.8″' },
      { code: 'XL', measure: '23.5″' }
    ];
    function capMeasure(cap) {
      var c = String(cap == null ? '' : cap);
      var m = c.match(/\(([^\)]+)\)/);
      if (m) return m[1].replace(/"/g, '\u2033');
      var m2 = c.match(/[\d.]+\s*(?:inch|in|\u2033|")/i);
      return m2 ? m2[0].replace(/"/g, '\u2033') : '';
    }
    function capInches(cap) {
      var c = String(cap == null ? '' : cap);
      var m = c.match(/([\d.]+)\s*(?:inch|in|\u2033|")/i);
      var v = m ? parseFloat(m[1]) : NaN;
      return isNaN(v) ? null : v;
    }
    function lookCapSizes(look) {
      var vs = (look && look.variants) || [];
      var seen = {};
      var out = [];
      vs.forEach(function (v) {
        var c = v && v.cap ? String(v.cap) : '';
        if (!c || seen[c]) return;
        seen[c] = true;
        out.push({ code: capCode(c), measure: capMeasure(c) || c, raw: c });
      });
      if (!out.length) return capFallbackSizes.slice();
      out.sort(function (a, b) {
        var ai = capInches(a.raw), bi = capInches(b.raw);
        if (ai != null && bi != null && ai !== bi) return ai - bi;
        var order = { XS: 0, S: 1, M: 2, L: 3, XL: 4, XXL: 5 };
        var ao = order[a.code] != null ? order[a.code] : 99;
        var bo = order[b.code] != null ? order[b.code] : 99;
        if (ao !== bo) return ao - bo;
        return String(a.raw).localeCompare(String(b.raw));
      });
      return out;
    }
    function capCode(cap) {
      var c = String(cap == null ? '' : cap).trim().toUpperCase();
      if (/EXTRA\s*SMALL|^XS\b/.test(c)) return 'XS';
      if (/\bSMALL\b|^S\b/.test(c)) return 'S';
      if (/\bMEDIUM\b|^M\b/.test(c)) return 'M';
      if (/EXTRA\s*LARGE|^XL\b/.test(c)) return 'XL';
      if (/\bLARGE\b|^L\b/.test(c)) return 'L';
      if (/XXL|2XL|EXTRA\s*EXTRA/.test(c)) return 'XXL';
      var m = c.match(/^([A-Z]+)/);
      return m ? m[1] : c;
    }
    function capVariantId(look, sizeCode) {
      var vs = (look && look.variants) || [];
      for (var i = 0; i < vs.length; i++) {
        if (capCode(vs[i] && vs[i].cap) === String(sizeCode).toUpperCase()) return vs[i].id;
      }
      /* numeric fallback: MEDIUM/SMALL full-word caps matched by inches (22", 19.5") */
      var want = capInches(sizeCode);
      if (want != null) {
        for (var j = 0; j < vs.length; j++) {
          if (capInches(vs[j] && vs[j].cap) === want) return vs[j].id;
        }
      }
      var avail = vs.filter(function (v) { return v && v.available !== false; });
      var pool = avail.length ? avail : vs;
      if (sizeCode === 'M' && pool.length) {
        var cheapest = pool[0];
        pool.forEach(function (v) { if (v.price != null && (cheapest.price == null || v.price < cheapest.price)) cheapest = v; });
        return cheapest.id;
      }
      return look ? look.variantId : null;
    }
    function openCapSizeDialog(index) {
      var look = looks[index == null ? currentIndex : Number(index)];
      if (!look) return;
      if (isFeather()) { ajaxAdd(look.variantId, null); return; }
      currentIndex = looks.indexOf(look);
      var img = $('[data-bwt="capLookImage"]');
      if (img) { img.src = lookImage(look); img.alt = look.title; }
      var t = $('[data-bwt="capLookTitle"]');
      if (t) t.textContent = productTitle || look.title;
      var pr = $('[data-bwt="capLookPrice"]');
      if (pr) pr.textContent = 'Starting at ' + money(look.price);
      var box = $('[data-bwt="capSizeOptions"]');
      if (box) {
        box.innerHTML = lookCapSizes(look).map(function (size) {
          return '<button type="button" data-cap-variant="' + capVariantId(look, size.raw || size.code) + '" aria-label="Add ' + size.code + ' cap, ' + size.measure + ', to cart">' +
            '<strong>' + size.code + '</strong><span>' + size.measure + '</span></button>';
        }).join('');
      }
      showDlg(capSizeDialog);
      track('cap_open', currentIndex);
    }
    function ajaxAdd(variantId, btn) {
      if (!variantId) { showToast('Variant unavailable'); return; }
      if (btn) btn.disabled = true;
      var sectionsToBundle = [];
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })); } catch (e) {}
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sectionsToBundle, sections_url: window.location.pathname })
      }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (data) {
          showToast('Added to cart');
          track('add_direct', currentIndex);
          var cartState = data;
          try {
            var drawer = document.querySelector('cart-drawer');
            var sid = drawer && drawer.getAttribute ? drawer.getAttribute('data-section-id') : null;
            if (window.theme && theme.utils && theme.utils.buildCartStateFromAddResponse && data && data.sections) {
              cartState = theme.utils.buildCartStateFromAddResponse(data, sid);
            }
          } catch (e) {}
          try {
            if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'braided-wig-try-on', productVariantId: variantId, cart: cartState });
          } catch (e) {}
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartState } }));
        })
        .catch(function () { showToast('Add to cart failed, please retry'); })
        .finally(function () { if (btn) btn.disabled = false; });
    }

    /* try-on */
    function renderMemberGate() {
      $('[data-bwt="memberGate"]').hidden = memberLoggedIn;
      $('[data-bwt="uploadPanel"]').hidden = !memberLoggedIn;
      var left = remaining();
      var input = $('[data-bwt="tryOnUpload"]');
      if (input) input.disabled = left === 0;
      var label = $('[data-bwt="tryOnUploadLabel"]');
      if (label) {
        label.textContent = left ? 'Choose your photo' : 'Try-On limit reached';
        label.classList.toggle('disabled', left === 0);
      }
      var msg = $('[data-bwt="uploadLimitMessage"]');
      if (msg) msg.textContent = QUOTA_COPY_ON ? (left ? left + '/10 Try-Ons remaining. Each Try-On creates one preview.' : 'You have used all 10 hairstyle Try-Ons today.') : 'Each Try-On creates one preview.';
    }
    function setTryOnState(state) {
      tryOnDialog.setAttribute('data-state', state);
      $('[data-bwt="tryOnUploadView"]').hidden = state !== 'upload';
      $('[data-bwt="tryOnLoadingView"]').hidden = state !== 'loading';
      $('[data-bwt="tryOnResultView"]').hidden = state !== 'result';
    }
    function openTryOn(index) {
      clearTryOnTimers();
      aiNoticeDismissed = false;
      var look = selectLook(index);
      if (!look) return;
      if (!tryOnAvailability(look).ok) {
        showToast('This combination is not available for try-on — try ' + (availableLengthsForColor(look.color).join(', ') || 'another color') + '.');
        return;
      }
      if (isOpen(galleryDialog)) hideDlg(galleryDialog);
      $('[data-bwt="tryOnLookImage"]').src = lookImage(look);
      $('[data-bwt="tryOnLookImage"]').alt = look.title;
      var selName = $('[data-bwt="tryOnSelectedLook"]');
      if (selName) selName.textContent = look.title;
      renderMemberGate();
      setTryOnState('upload');
      if (!isOpen(tryOnDialog)) { leaveReminderShown = false; showDlg(tryOnDialog); }
      track('tryon_open', currentIndex);
    }
    function stopPolling() {
      if (pollingSource) { try { pollingSource.close(); } catch (e) {} pollingSource = null; }
      if (pollingBackstop) { clearTimeout(pollingBackstop); pollingBackstop = null; }
    }
    function generateWithCurrentPhoto() {
      if (!uploadedPhotoUrl || remaining() <= 0) return false;
      if (!memberLoggedIn) { renderMemberGate(); showToast('Log in to use Virtual Try-On.'); return false; }
      if (pendingPhotoFile) { submitBackendTryOn(pendingPhotoFile); return true; }
      showToast('Please choose your photo first.');
      return false;
    }
    function backendLoadingView(photoUrl, used, wigUrl) {
      clearTryOnTimers();
      $('[data-bwt="loadingUserPhoto"]').src = photoUrl;
      var lw = $('[data-bwt="loadingWigPhoto"]');
      if (lw) { if (wigUrl) lw.src = wigUrl; else lw.removeAttribute('src'); }
      if (QUOTA_COPY_ON) $('[data-bwt="loadingAllowance"]').textContent = 'You\u2019ve generated ' + used + ' hairstyle' + (used === 1 ? '' : 's') + ' today \u00b7 ' + (TRY_ON_LIMIT - used) + ' Try-Ons remaining';
      setTryOnState('loading');
      var elapsed = 0;
      $('[data-bwt="loadingElapsed"]').textContent = '0 seconds';
      var steps = Array.prototype.slice.call(tryOnDialog.querySelectorAll('.loading-steps li'));
      steps.forEach(function (step, i) { step.className = i === 0 ? 'active' : ''; });
      clearInterval(elapsedTimer);
      elapsedTimer = setInterval(function () {
        elapsed += 1;
        $('[data-bwt="loadingElapsed"]').textContent = elapsed + ' second' + (elapsed === 1 ? '' : 's');
        var active = Math.min(Math.floor(elapsed / 1.1), steps.length - 1);
        steps.forEach(function (step, i) { step.className = i < active ? 'done' : i === active ? 'active' : ''; });
      }, 1000);
    }
    function uuid() {
      if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
      return 'id-' + Date.now() + '-' + Math.floor(Math.random() * 1e9);
    }
    /* 用户自拍上传前压缩：最长边 1536px、JPEG 0.85。工作流内会缩到 1.5MP，
       原图直传只是浪费 S3 上传 + worker 下载时间。失败/小图则回退原文件。 */
    function compressPhotoForUpload(file) {
      return new Promise(function (resolve) {
        try {
          if (!file || file.type === 'image/gif') { resolve(file); return; }
          if (file.size <= 600 * 1024) { resolve(file); return; }
          var url = URL.createObjectURL(file);
          var img = new Image();
          img.onload = function () {
            URL.revokeObjectURL(url);
            try {
              var w = img.naturalWidth || img.width;
              var h = img.naturalHeight || img.height;
              if (!w || !h) { resolve(file); return; }
              var maxSide = 1536;
              var scale = Math.min(1, maxSide / Math.max(w, h));
              if (scale >= 1 && file.size <= 1024 * 1024) { resolve(file); return; }
              var cw = Math.max(1, Math.round(w * scale));
              var ch = Math.max(1, Math.round(h * scale));
              var canvas = document.createElement('canvas');
              canvas.width = cw; canvas.height = ch;
              var ctx = canvas.getContext('2d');
              if (!ctx) { resolve(file); return; }
              ctx.drawImage(img, 0, 0, cw, ch);
              if (!canvas.toBlob) { resolve(file); return; }
              canvas.toBlob(function (blob) {
                if (!blob || blob.size >= file.size) { resolve(file); return; }
                resolve(blob);
              }, 'image/jpeg', 0.85);
            } catch (e) { resolve(file); }
          };
          img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
          img.src = url;
        } catch (e) { resolve(file); }
      });
    }
    function submitBackendTryOn(file, target) {
      var look = target && target.entry ? looks[target.entry.lookIndex] : currentLook();
      if (!look) return false;
      var wig = wigReferenceImage(look);
      if (!wig.src) {
        try {
          console.warn('[braided-tryon] no wig reference', {
            color: look.color, length: look.length,
            mediaCount: productMedia.length,
            alts: productMedia.map(function (m) { return (m && m.alt) || ''; })
          });
        } catch (e) {}
        var availLens = availableLengthsForColor(look.color);
        showToast(availLens.length
          ? 'This combination is not available for try-on — ' + look.color + ' try-on available in ' + availLens.join(', ') + '.'
          : 'This combination is not available for try-on — try another color.');
        return false;
      }
      if (remaining() <= 0) { showToast('You have used all 10 hairstyle Try-Ons today.'); return false; }
      if (!target && submittingTryOn) return false;
      var wigUrl = wig.src || '';
      if (wigUrl.indexOf('//') === 0) wigUrl = 'https:' + wigUrl;
      if (!target) {
        submittingTryOn = true;
        if (uploadedPhotoUrl) URL.revokeObjectURL(uploadedPhotoUrl);
        uploadedPhotoUrl = URL.createObjectURL(file);
        backendLoadingView(uploadedPhotoUrl, getCount() + 1, wigUrl);
      }
      pendingPhotoFile = file;
      compressPhotoForUpload(file).then(function (uploadFile) {
        pendingPhotoFile = uploadFile;
        var form = new FormData();
        form.append('photo', uploadFile, (file && file.name) || 'selfie.jpg');
      form.append('productId', String(productId));
      form.append('color', look.color || '');
      form.append('length', String(look.length == null ? '' : look.length));
      form.append('wigImageUrl', wigUrl);
      form.append('wigAlt', wig.alt || '');
      form.append('clientRequestId', uuid());
        return fetch(TRYON_API, { method: 'POST', body: form, credentials: 'same-origin' });
      }).then(function (r) {
        if (r.status === 429) throw new Error('quota');
        if (r.status === 401) throw new Error('login');
        if (!r.ok) throw new Error('submit');
        return r.json();
      }).then(function (body) {
        if (!body || !body.jobId) throw new Error('submit');
        track(target ? 'tryon_regen_submit' : 'tryon_submit', target ? target.entry.lookIndex : currentIndex);
        pollBackendJob(body.jobId, look, target);
      }).catch(function (err) {
        clearInterval(elapsedTimer);
        submittingTryOn = false;
        if (target && target.entry) {
          target.entry.regeneratingView = '';
          if (target.button && target.markup != null) target.button.innerHTML = target.markup;
          renderResult(target.entry);
        } else {
          setTryOnState('upload');
        }
        if (err && err.message === 'quota') { setCount(TRY_ON_LIMIT); renderMemberGate(); showToast('You have used all 10 hairstyle Try-Ons today.'); }
        else if (err && err.message === 'login') { renderMemberGate(); showToast('Log in to use Virtual Try-On.'); }
        else showToast('Try-On failed, please retry.');
      });
      return true;
    }
    function pollBackendJob(jobId, look, target) {
      stopPolling();
      var url = TRYON_EVENTS + '?ids=' + encodeURIComponent(jobId);
      var source = new EventSource(url);
      pollingSource = source;
      source.addEventListener('message', function (event) {
        var data = null;
        try { data = JSON.parse(event.data); } catch (e) { return; }
        if (!data || data.type !== 'job' || !data.job) return;
        var job = data.job;
        if (job.status === 'done' && job.resultUrl) {
          stopPolling();
          if (pollingBackstop) { clearTimeout(pollingBackstop); pollingBackstop = null; }
          submittingTryOn = false;
          clearInterval(elapsedTimer);
          if (target && target.entry) {
            target.entry[target.kind || 'front'] = job.resultUrl;
            var tc = target.entry.regenerationCounts || (target.entry.regenerationCounts = { front: 0, side: 0 });
            tc[target.kind || 'front'] += 1;
            target.entry.regeneratingView = '';
            renderResult(target.entry);
            if (target.button && target.markup != null) target.button.innerHTML = target.markup;
            showToast((target.kind === 'side' ? 'Side' : 'Front') + ' view regenerated.');
            track('tryon_regen_done', target.entry.lookIndex);
          } else {
            var entry = {
              id: job.jobId || String(Date.now()),
              lookIndex: looks.indexOf(look),
              photo: uploadedPhotoUrl,
              title: look.title,
              front: job.resultUrl,
              side: '',
              regenerationCounts: { front: 0, side: 0 },
              regeneratingView: ''
            };
            if (entry.lookIndex < 0) entry.lookIndex = currentIndex;
            history.unshift(entry);
            history = history.slice(0, TRY_ON_LIMIT);
            activeHistoryId = entry.id;
            renderResult(entry);
            setTryOnState('result');
            track('tryon_done', entry.lookIndex);
          }
        } else if (job.status === 'failed' || job.status === 'cancelled') {
          stopPolling();
          submittingTryOn = false;
          clearInterval(elapsedTimer);
          if (target && target.entry) {
            target.entry.regeneratingView = '';
            if (target.button && target.markup != null) target.button.innerHTML = target.markup;
            renderResult(target.entry);
            showToast('Try-On failed, please retry.');
          } else {
            setTryOnState('upload');
            showToast('Try-On failed, please retry.');
          }
        }
      });
      source.addEventListener('error', function () {
        /* SSE 异常/断开且长时间无终态：释放提交锁回上传态，避免二次上传被锁死 */
        clearTimeout(pollingBackstop);
        pollingBackstop = setTimeout(function () {
          stopPolling();
          clearInterval(elapsedTimer);
          submittingTryOn = false;
          if (target && target.entry) {
            target.entry.regeneratingView = '';
            renderResult(target.entry);
          } else {
            setTryOnState('upload');
          }
          showToast('Connection lost, please retry.');
        }, 90000);
      });
    }
    function loadBackendHistory() {
      if (!memberLoggedIn || historyLoaded) return;
      historyLoaded = true;
      fetch(TRYON_API + '?product_id=' + encodeURIComponent(String(productId)), { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('history');
        return r.json();
      }).then(function (body) {
        var items = (body && body.items) || [];
        items.forEach(function (item) {
          if (!item.resultUrl) return;
          var lookIndex = currentIndex;
          for (var i = 0; i < looks.length; i++) {
            if (looks[i].color === item.color && String(looks[i].length) === String(item.length)) { lookIndex = i; break; }
          }
          history.push({
            id: item.jobId,
            lookIndex: lookIndex,
            photo: '',
            title: looks[lookIndex] ? looks[lookIndex].title : '',
            front: item.resultUrl,
            side: '',
            regenerationCounts: { front: 0, side: 0 },
            regeneratingView: ''
          });
        });
        /* 历史仅预载数据供结果页回看，不自动跳转；入口统一走上传态重新生产。 */
      }).catch(function () { /* 历史失败不阻塞试戴 */ });
    }
    function startGeneration(file) {
      if (!file) return;
      if (remaining() <= 0) { showToast('You have used all 10 hairstyle Try-Ons today.'); return; }
      if (!memberLoggedIn) { renderMemberGate(); showToast('Log in to use Virtual Try-On.'); return; }
      if (uploadedPhotoUrl) URL.revokeObjectURL(uploadedPhotoUrl);
      uploadedPhotoUrl = URL.createObjectURL(file);
      pendingPhotoFile = file;
      loadBackendHistory();
      generateWithCurrentPhoto();
    }

    function activeEntry() {
      for (var i = 0; i < history.length; i++) {
        if (history[i].id === activeHistoryId) return history[i];
      }
      return null;
    }

    function renderResult(entryArg) {
      var entry = entryArg || activeEntry();
      if (!entry) {
        for (var i = 0; i < history.length; i++) {
          if (history[i].lookIndex === currentIndex) { entry = history[i]; break; }
        }
      }
      if (!entry) return;
      activeHistoryId = entry.id;
      currentIndex = entry.lookIndex;
      var look = currentLook();
      if (!look) return;
      var selName2 = $('[data-bwt="tryOnSelectedLook"]');
      if (selName2) selName2.textContent = look.title;
      var resTitle = $('[data-bwt="resultLookTitle"]');
      if (resTitle) resTitle.textContent = look.title;
      var counts = entry.regenerationCounts || (entry.regenerationCounts = { front: 0, side: 0 });
      var frontLimit = counts.front >= 5;

      $('[data-bwt="tryOnFrontResult"]').src = entry.front || lookImage(look);
      $('[data-bwt="tryOnFrontResult"]').alt = look.title + ' primary Virtual Try-On result';
      $$('[data-regenerate-result]').forEach(function (button) {
        if (button.classList.contains('secondary')) button.hidden = frontLimit;
        button.disabled = Boolean(entry.regeneratingView);
        button.title = 'Replace only this AI preview';
      });
      if (!entry.regeneratingView) {
        $$('[data-regenerating-view]').forEach(function (o) { o.hidden = true; });
      }

      var notice = document.querySelector('.braided-wig-try-on-scope .ai-preview-notice');
      if (notice) notice.hidden = aiNoticeDismissed;

      $('[data-bwt="resultKitTitle"]').textContent = productTitle || look.title;
      var eyebrow = $('[data-bwt="resultKitEyebrow"]');
      if (eyebrow) eyebrow.textContent = isFeather() ? 'Your selected feather hair' : 'Your selected wig';
      var colorRow = $('[data-bwt="resultColorRow"]');
      if (colorRow) colorRow.hidden = isFeather();
      if (!isFeather()) $('[data-bwt="resultColor"]').textContent = look.color || '';
      var rLenRow = $('[data-bwt="resultLengthRow"]');
      if (!isFeather()) {
        $('[data-bwt="resultLength"]').textContent = lookHasLength(look) ? lenLabel(look.length) : '';
        if (rLenRow) rLenRow.hidden = !lookHasLength(look);
      } else if (rLenRow) {
        $('[data-bwt="resultLength"]').textContent = look.base || '';
        rLenRow.hidden = !$('[data-bwt="resultLength"]').textContent.trim();
      }
      $('[data-bwt="resultPrice"]').textContent = look.price != null ? money(look.price) : '';
      if (QUOTA_COPY_ON) $('[data-bwt="tryOnRemaining"]').textContent = remaining() + '/10 Try-Ons remaining';
      renderTryOnHistory();
      var rk = $('[data-bwt="resultBuy"]');
      if (rk) {
        if (lookHasCap(look)) { rk.setAttribute('data-cap-shop', String(currentIndex)); rk.removeAttribute('data-buy'); rk.textContent = 'Choose cap size & add to cart'; }
        else { rk.setAttribute('data-buy', String(currentIndex)); rk.removeAttribute('data-cap-shop'); rk.textContent = 'Add to cart'; }
        rk.toggleAttribute('disabled', !look.variantId);
        rk.hidden = false;
      }
    }

    function renderTryOnHistory() {
      var list = $('[data-bwt="tryOnHistoryList"]');
      var wrap = $('[data-bwt="tryOnHistory"]');
      if (!list || !wrap) return;
      wrap.hidden = history.length === 0;
      var count = $('[data-bwt="tryOnHistoryCount"]');
      if (count) count.textContent = QUOTA_COPY_ON ? remaining() + '/10 Try-Ons remaining' : '';
      list.innerHTML = '';
      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'try-on-history-item upload-new';
      add.setAttribute('data-history-entry', '__new');
      add.setAttribute('aria-label', 'Upload a new photo');
      add.innerHTML = '<span aria-hidden="true">＋</span><strong>Upload a new photo</strong>';
      add.disabled = remaining() <= 0;
      add.title = remaining() <= 0 ? 'You have used all 10 hairstyle Try-Ons today.' : 'Upload a new photo';
      list.appendChild(add);
      history.forEach(function (item) {
        var look = looks[item.lookIndex];
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'try-on-history-item' + (item.id === activeHistoryId ? ' active' : '');
        btn.setAttribute('data-history-entry', item.id);
        var title = item.title || (look ? look.title : 'Try-On');
        var src = item.front || (look ? lookImage(look) : '');
        var span = document.createElement('span');
        span.className = 'single';
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.loading = 'lazy';
        span.appendChild(img);
        var label = document.createElement('strong');
        label.textContent = title;
        btn.appendChild(span);
        btn.appendChild(label);
        btn.setAttribute('aria-label', 'Review ' + title + ' Try-On');
        list.appendChild(btn);
      });
    }
    function switchHistoryEntry(id) {
      if (id === '__new') {
        if (submittingTryOn) { showToast('Your photo is being processed, please wait.'); return; }
        if (remaining() <= 0) { showToast('You have used all 10 hairstyle Try-Ons today.'); return; }
        setTryOnState('upload');
        return;
      }
      for (var i = 0; i < history.length; i++) {
        if (history[i].id === id) { renderResult(history[i]); setTryOnState('result'); return; }
      }
    }

    function openResultPhoto(kind) {
      var entry = activeEntry();
      if (!entry) return;
      var isPrimary = kind !== 'side';
      var source = isPrimary ? entry.front : entry.side;
      if (!source) return;
      enlargedResultKind = isPrimary ? 'front' : 'side';
      $('[data-bwt="photoDialogTitle"]').textContent = isPrimary ? 'Your Preview' : 'Different Angle';
      var img = $('[data-bwt="photoDialogImage"]');
      img.src = source;
      img.alt = entry.title + ' ' + (isPrimary ? 'primary' : 'different-angle') + ' Virtual Try-On preview';
      var counts = entry.regenerationCounts || (entry.regenerationCounts = { front: 0, side: 0 });
      var regen = $('[data-bwt="regenerateEnlargedPhoto"]');
      if (regen) regen.hidden = counts[enlargedResultKind] >= 5;
      showDlg(photoDialog);
    }

    /* 方案 A：regenerate 走后端新单（同产品/同色长/同自拍重跑，扣配额 1 次，单图 5 次上限）。 */
    function regenerateTryOnResult(kind, button) {
      var entry = activeEntry();
      if (!entry || entry.regeneratingView) return;
      var counts = entry.regenerationCounts || (entry.regenerationCounts = { front: 0, side: 0 });
      if (counts[kind] >= 5) {
        showToast('This picture has reached its five-regeneration limit.');
        return;
      }
      if (remaining() <= 0) { showToast('You have used all 10 hairstyle Try-Ons today.'); return; }
      if (!memberLoggedIn) { renderMemberGate(); showToast('Log in to use Virtual Try-On.'); return; }
      var file = pendingPhotoFile;
      if (!file) { showToast('Please upload your photo again to regenerate.'); return; }
      var look = looks[entry.lookIndex];
      var wig = look ? wigReferenceImage(look) : { src: '', alt: '' };
      if (!wig.src) { showToast('No mannequin photo for ' + (look ? look.color + ' ' + lenLabel(look.length) : 'this look') + ' yet — try another color or length.'); return; }
      entry.regeneratingView = kind;
      var overlay = null;
      $$('[data-regenerating-view]').forEach(function (o) { if (o.getAttribute('data-regenerating-view') === kind) overlay = o; });
      if (overlay) overlay.hidden = false;
      $$('[data-regenerate-result]').forEach(function (c) { c.disabled = true; });
      var originalMarkup = button ? button.innerHTML : '';
      if (button) { button.innerHTML = '<span aria-hidden="true">↻</span> Regenerating'; button.disabled = true; }
      submitBackendTryOn(file, { entry: entry, kind: kind, button: button || null, markup: originalMarkup });
    }

    function resultSource(kind, fallbackSelector) {
      var entry = activeEntry();
      if (entry) {
        var src = kind === 'side' ? entry.side : entry.front;
        if (src) return src;
      }
      var img = $(fallbackSelector);
      return img ? (img.currentSrc || img.src) : '';
    }
    function resultFileName(kind) {
      var safe = currentLook().title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      return 'jaliza-' + safe + '-' + (kind === 'side' ? 'different-angle' : 'primary-view');
    }
    function downloadUrl(url, name, btn, doneLabel) {
      if (!url) { showToast('This preview could not be downloaded. Please try again.'); return; }
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Preparing…'; }
      var directSave = function (href, ext, revoke) {
        var link = document.createElement('a');
        link.href = href; link.download = name + '.' + (ext || 'webp');
        link.rel = 'noopener';
        document.body.appendChild(link); link.click(); link.remove();
        if (revoke) setTimeout(function () { URL.revokeObjectURL(href); }, 1000);
        showToast(doneLabel || 'Preview downloaded.');
        if (btn) { btn.disabled = false; btn.innerHTML = original; }
      };
      fetch(url, { mode: 'cors' }).then(function (r) { if (!r.ok) throw new Error('dl'); return r.blob(); }).then(function (blob) {
        var ext = blob.type.indexOf('png') !== -1 ? 'png' : blob.type.indexOf('jpeg') !== -1 ? 'jpg' : 'webp';
        directSave(URL.createObjectURL(blob), ext, true);
      }).catch(function () {
        /* CORS/预签名失败兜底：新标签页打开原图，用户可长按/右键另存 */
        if (btn) { btn.disabled = false; btn.innerHTML = original; }
        try { window.open(url, '_blank', 'noopener'); } catch (e) { window.location.href = url; }
        showToast('Opened full image — save it from the new tab.');
      });
    }
    function shareMenuFor(kind) {
      if (kind === 'enlarged') kind = enlargedResultKind;
      var menu = null;
      $$('[data-share-menu]').forEach(function (m) { if (m.getAttribute('data-share-menu') === kind) menu = m; });
      return menu;
    }
    function closeShareMenus(except) {
      $$('[data-share-menu]').forEach(function (m) { if (m !== except) m.hidden = true; });
      $$('[data-share-result]').forEach(function (b) { if (!except || !b.parentNode || b.parentNode.querySelector('[data-share-menu]') !== except) b.setAttribute('aria-expanded', 'false'); });
      var eb = $('[data-bwt="shareEnlargedPhoto"]');
      if (eb && (!except || !eb.parentNode || eb.parentNode.querySelector('[data-share-menu]') !== except)) eb.setAttribute('aria-expanded', 'false');
    }
    function toggleShareMenu(kind, btn) {
      var menu = shareMenuFor(kind);
      if (!menu) { shareChannel(kind === 'enlarged' ? enlargedResultKind : kind, 'system', btn); return; }
      var willOpen = menu.hidden;
      closeShareMenus();
      menu.hidden = !willOpen;
      if (btn) btn.setAttribute('aria-expanded', String(willOpen));
    }
    function shareText(kind) {
      return 'My JALIZA Virtual Try-On: ' + currentLook().title + (kind === 'side' ? ' (Different Angle)' : '');
    }
    function openShareUrl(url) {
      window.open(url, '_blank', 'noopener,noreferrer,width=640,height=560');
    }
    function copyText(text, okMsg) {
      var done = function () { showToast(okMsg || 'Copied'); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function () { showToast('Copy failed, please copy manually'); });
      } else {
        var ta = document.createElement('textarea');
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); done(); } catch (e) { showToast('Copy failed, please copy manually'); }
        ta.remove();
      }
    }
    function shareChannel(kind, channel, btn) {
      closeShareMenus();
      var pageUrl = window.location.href;
      if (channel === 'copy') {
        var src = resultSource(kind, kind === 'side' ? '[data-bwt="tryOnSideResult"]' : '[data-bwt="tryOnFrontResult"]');
        copyText(src, 'Image link copied');
        return;
      }
      if (channel === 'facebook') {
        openShareUrl('https://www.facebook.com/sharer.php?u=' + encodeURIComponent(pageUrl));
        return;
      }
      if (channel === 'whatsapp') {
        openShareUrl('https://wa.me/?text=' + encodeURIComponent(shareText(kind) + ' ' + pageUrl));
        return;
      }
      if (channel === 'instagram' || channel === 'tiktok') {
        /* no web share-intent: copy the preview link, user pastes in the app */
        var imgSrc = resultSource(kind, kind === 'side' ? '[data-bwt="tryOnSideResult"]' : '[data-bwt="tryOnFrontResult"]');
        copyText(imgSrc, 'Image link copied — paste it in ' + (channel === 'instagram' ? 'Instagram' : 'TikTok'));
        return;
      }
      /* system: native file share where supported, else download */
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Preparing…'; }
      var url = resultSource(kind, kind === 'side' ? '[data-bwt="tryOnSideResult"]' : '[data-bwt="tryOnFrontResult"]');
      fetch(url, { mode: 'cors' }).then(function (r) { if (!r.ok) throw new Error('share'); return r.blob(); }).then(function (blob) {
        var ext = blob.type.indexOf('png') !== -1 ? 'png' : blob.type.indexOf('jpeg') !== -1 ? 'jpg' : 'webp';
        var file = new File([blob], resultFileName(kind) + '.' + ext, { type: blob.type });
        var data = { title: currentLook().title + (kind === 'side' ? ' Different Angle' : ' Primary View'), text: shareText(kind), files: [file] };
        if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) return navigator.share(data);
        var obj = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = obj; link.download = resultFileName(kind) + '.' + ext;
        document.body.appendChild(link); link.click(); link.remove();
        setTimeout(function () { URL.revokeObjectURL(obj); }, 1000);
        showToast((kind === 'side' ? 'Different-angle' : 'Primary') + ' preview downloaded. Share it from your device.');
      }).catch(function (err) {
        if (!err || err.name !== 'AbortError') showToast('Sharing is not available. Please save the image instead.');
      }).finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
    }
    function shareResult(kind, btn) {
      toggleShareMenu(kind, btn);
    }
    function tryToCloseTryOn() {
      if (history.length && !leaveReminderShown) {
        leaveReminderShown = true;
        showDlg(leaveDialog);
      } else {
        hideDlg(tryOnDialog);
      }
    }

    /* tutorial: flat video list across 3 sections */
    function allVideos() {
      var out = [];
      tutorialSections.forEach(function (item, sectionIndex) {
        item.videos.forEach(function (clip, videoIndex) { out.push({ sectionIndex: sectionIndex, videoIndex: videoIndex, clip: clip }); });
      });
      return out;
    }
    function renderTutorial() {
      var look = currentLook();
      if (!look) return;
      var section = tutorialSections[tutorialIndex];
      if (!section) return;
      var video = section.videos[tutorialVideoIndex] || section.videos[0];
      var flat = allVideos();
      var pos = 0;
      flat.forEach(function (item, i) { if (item.sectionIndex === tutorialIndex && item.videoIndex === tutorialVideoIndex) pos = i; });
      $('[data-bwt="selectedLookImage"]').src = lookImage(look);
      $('[data-bwt="selectedLookImage"]').alt = productTitle || look.title;
      /* Beta placeholder: tutorial frame shows selected look image (final videos pending) */
      $('[data-bwt="tutorialVideoImage"]').src = lookImage(look);
      $('[data-bwt="videoStage"]').textContent = 'Section ' + (tutorialIndex + 1) + ' · ' + section.name;
      $('[data-bwt="videoLabel"]').textContent = video.title;
      $('[data-bwt="stageName"]').textContent = 'Section ' + (tutorialIndex + 1) + ' · ' + section.name;
      $('[data-bwt="stepCount"]').textContent = 'Video ' + (tutorialVideoIndex + 1) + ' / ' + section.videos.length;
      $('[data-bwt="stepTitle"]').textContent = video.title;
      $('[data-bwt="stepDescription"]').textContent = video.description;
      $('[data-bwt="stepCue"]').textContent = video.cue;
      $('[data-bwt="goodLooks"]').textContent = section.teaches;
      $('[data-bwt="navStepNumber"]').textContent = ('0' + (pos + 1)).slice(-2) + ' / ' + ('0' + flat.length).slice(-2);
      $('[data-bwt="previousStep"]').disabled = pos === 0;
      $('[data-bwt="nextStep"]').disabled = pos === flat.length - 1;
      $('[data-bwt="kitColor"]').textContent = look.color;
      var kitLenCell = $('[data-bwt="kitLengthCell"]');
      if (kitLenCell) {
        $('[data-bwt="kitLength"]').textContent = lookHasLength(look) ? lenLabel(look.length) : '';
        kitLenCell.hidden = !lookHasLength(look);
      } else $('[data-bwt="kitLength"]').textContent = lookHasLength(look) ? lenLabel(look.length) : '';
      $('[data-bwt="kitPrice"]').textContent = money(look.price);
      var kt = $('[data-bwt="tutorialBuy"]');
      if (kt) {
        if (lookHasCap(look)) { kt.setAttribute('data-cap-shop', String(currentIndex)); kt.removeAttribute('data-buy'); kt.textContent = 'Choose cap size & add to cart'; }
        else { kt.setAttribute('data-buy', String(currentIndex)); kt.removeAttribute('data-cap-shop'); kt.textContent = 'Add to cart'; }
        kt.toggleAttribute('disabled', !look.variantId);
      }
      $('[data-bwt="dialogStageProgress"]').style.setProperty('--section-count', tutorialSections.length);
      $('[data-bwt="dialogStageProgress"]').innerHTML = tutorialSections.map(function (item, i) {
        return '<button type="button" data-section="' + i + '" class="' + (i < tutorialIndex ? 'done' : i === tutorialIndex ? 'current' : '') + '"><i></i><span>' + (i + 1) + '. ' + item.name + '</span></button>';
      }).join('');
      $('[data-bwt="outlineScroll"]').innerHTML = tutorialSections.map(function (item, sectionIndex) {
        return '<section class="outline-stage"><div class="outline-stage-title"><span>' + (sectionIndex + 1) + '. ' + item.name + '</span><small>' + item.videos.length + ' video' + (item.videos.length === 1 ? '' : 's') + '</small></div>' +
          item.videos.map(function (clip, videoIndex) {
            var clipPos = 0;
            flat.forEach(function (entry, i) { if (entry.sectionIndex === sectionIndex && entry.videoIndex === videoIndex) clipPos = i; });
            var isCurrent = sectionIndex === tutorialIndex && videoIndex === tutorialVideoIndex;
            return '<button type="button" class="outline-step ' + (isCurrent ? 'current' : '') + '" data-tutorial-video="' + sectionIndex + ':' + videoIndex + '"><span class="number">' + ('0' + (videoIndex + 1)).slice(-2) + '</span><span class="copy"><strong>' + esc(clip.title) + '</strong></span><span class="state">' + (clipPos < pos ? '✓' : isCurrent ? 'Now' : '') + '</span></button>';
          }).join('') + '</section>';
      }).join('');
      var bar = $('[data-bwt="videoProgress"]');
      if (bar) {
        bar.classList.remove('playing');
        void bar.offsetWidth;
        if ($('[data-bwt="playButton"]').getAttribute('aria-pressed') === 'true') bar.classList.add('playing');
      }
    }
    function openTutorial(index) {
      selectLook(index);
      tutorialIndex = 0;
      tutorialVideoIndex = 0;
      if (isOpen(galleryDialog)) hideDlg(galleryDialog);
      if (isOpen(tryOnDialog)) hideDlg(tryOnDialog);
      var shell = tutorialDialog ? tutorialDialog.querySelector('.tutorial-shell') : null;
      if (shell) shell.classList.remove('show-outline');
      renderTutorial();
      showDlg(tutorialDialog);
      track('tutorial_open', currentIndex);
    }
    function moveTutorialVideo(direction) {
      var flat = allVideos();
      var pos = 0;
      flat.forEach(function (item, i) { if (item.sectionIndex === tutorialIndex && item.videoIndex === tutorialVideoIndex) pos = i; });
      var next = Math.max(0, Math.min(flat.length - 1, pos + direction));
      tutorialIndex = flat[next].sectionIndex;
      tutorialVideoIndex = flat[next].videoIndex;
      renderTutorial();
    }

    /* events: delegated (works after x-modal body-append) */
    function handleBwtClick(event) {
      var q = function (s) { return event.target.closest ? event.target.closest(s) : null; };
      var cmpPhoto = q('[data-comparison-photo]');
      if (cmpPhoto) {
        comparisonPhotoIndices[Number(cmpPhoto.dataset.comparisonSide)] = Number(cmpPhoto.dataset.comparisonPhoto);
        renderComparisonDialog();
        return;
      }
      var gCmpBtn = q('[data-gallery-compare]');
      if (gCmpBtn) {
        toggleComparison(gCmpBtn.getAttribute('data-gallery-compare'));
        if (isOpen(galleryDialog) && comparedLooks.length === 2) hideDlg(galleryDialog);
        return;
      }
      var rmCmp = q('[data-remove-comparison]');
      if (rmCmp) { toggleComparison(rmCmp.dataset.removeComparison); return; }
      var openCmp = q('[data-open-comparison]');
      if (openCmp) { if (comparedLooks.length === 2) openComparisonDialog(); return; }
      var cmpBtn = q('[data-compare-look]');
      if (cmpBtn) { toggleComparison(cmpBtn.dataset.compareLook); return; }
      var gAngle = q('[data-gallery-angle]');
      if (gAngle) { galleryPhoto = Number(gAngle.dataset.galleryAngle); renderGallery(); return; }
      var gallery = q('[data-gallery]');
      if (gallery) { openGallery(gallery.dataset.gallery, gallery.dataset.galleryPhoto || 0); return; }
      var tryBtn = q('[data-try-on]');
      if (tryBtn) {
        if (tryBtn.disabled) {
          var dl = looks[Number(tryBtn.dataset.tryOn)];
          showToast(dl ? ('This combination is not available for try-on — try ' + (availableLengthsForColor(dl.color).join(', ') || 'another color') + '.') : 'This combination is not available for try-on.');
          return;
        }
        openTryOn(tryBtn.dataset.tryOn); return;
      }
      var tutBtn = q('[data-tutorial]');
      if (tutBtn) { openTutorial(tutBtn.dataset.tutorial); return; }
      var sec = q('[data-section]');
      if (sec) {
        tutorialIndex = Number(sec.dataset.section);
        tutorialVideoIndex = 0;
        var shell = tutorialDialog ? tutorialDialog.querySelector('.tutorial-shell') : null;
        if (shell) shell.classList.remove('show-outline');
        renderTutorial();
        return;
      }
      var tv = q('[data-tutorial-video]');
      if (tv) {
        var parts = tv.dataset.tutorialVideo.split(':');
        tutorialIndex = Number(parts[0]);
        tutorialVideoIndex = Number(parts[1]);
        var shell2 = tutorialDialog ? tutorialDialog.querySelector('.tutorial-shell') : null;
        if (shell2) shell2.classList.remove('show-outline');
        renderTutorial();
        return;
      }
      var histBtn = q('[data-history-entry]');
      if (histBtn) { switchHistoryEntry(histBtn.getAttribute('data-history-entry')); return; }
      var featherBuy = q('[data-feather-buy]');
      if (featherBuy) {
        var fIdx = featherBuy.getAttribute('data-feather-buy');
        var fLook = looks[fIdx === '' || fIdx == null ? currentIndex : Number(fIdx)];
        if (!fLook) return;
        currentIndex = looks.indexOf(fLook);
        ajaxAdd(fLook.variantId, featherBuy);
        track('add_feather', currentIndex);
        return;
      }
      var capShop = q('[data-cap-shop]');
      if (capShop) {
        if (capShop.tagName === 'A') event.preventDefault();
        var cIdx = capShop.getAttribute('data-cap-shop');
        openCapSizeDialog(cIdx === '' || cIdx == null ? currentIndex : Number(cIdx));
        return;
      }
      var capBtn = q('[data-cap-variant]');
      if (capBtn && (root.contains(capBtn) || (capSizeDialog && capSizeDialog.contains(capBtn)))) {
        ajaxAdd(capBtn.getAttribute('data-cap-variant'), capBtn);
        track('add_cap', currentIndex);
        hideDlg(capSizeDialog);
        return;
      }
      var buyBtn = q('[data-buy]');
      if (buyBtn) {
        if (buyBtn.tagName === 'A') event.preventDefault();
        var bIdx = buyBtn.getAttribute('data-buy');
        var bLook = looks[bIdx === '' || bIdx == null ? currentIndex : Number(bIdx)];
        if (!bLook) return;
        currentIndex = looks.indexOf(bLook);
        ajaxAdd(bLook.variantId, buyBtn);
        track('add_direct', currentIndex);
        return;
      }
      var capClose = q('[data-bwt="capSizeClose"]');
      if (capClose) { hideDlg(capSizeDialog); return; }
      var enl = q('[data-enlarge-result]');
      if (enl) { openResultPhoto(enl.getAttribute('data-enlarge-result')); return; }
      var regen = q('[data-regenerate-result]');
      if (regen) { regenerateTryOnResult(regen.getAttribute('data-regenerate-result'), regen); return; }
      var channel = q('[data-share-channel]');
      if (channel) {
        var menu = channel.closest ? channel.closest('[data-share-menu]') : null;
        var scope = menu ? menu.getAttribute('data-share-menu') : 'front';
        if (scope === 'enlarged') scope = enlargedResultKind;
        var wrapBtn = menu && menu.parentNode ? menu.parentNode.querySelector('[data-share-result], [data-bwt="shareEnlargedPhoto"]') : null;
        shareChannel(scope, channel.getAttribute('data-share-channel'), wrapBtn || channel);
        return;
      }
      var share = q('[data-share-result]');
      if (share) { shareResult(share.getAttribute('data-share-result'), share); return; }
      var dl = q('[data-download-result]');
      if (dl) {
        var kind = dl.getAttribute('data-download-result');
        downloadUrl(resultSource(kind, kind === 'side' ? '[data-bwt="tryOnSideResult"]' : '[data-bwt="tryOnFrontResult"]'), resultFileName(kind), dl, (kind === 'side' ? 'Different-angle' : 'Primary') + ' preview downloaded.');
        return;
      }
      var pb = q('[data-playback]');
      if (pb) {
        $$('[data-playback]').forEach(function (item) { item.classList.toggle('active', item === pb); });
        var strong = pb.querySelector('strong');
        showToast((strong ? strong.textContent : 'Mode') + ' selected');
        return;
      }
    }
    root.addEventListener('click', handleBwtClick);
    allDialogs.forEach(function (d) { if (d) d.addEventListener('click', handleBwtClick); });
    document.addEventListener('click', function (event) {
      var inside = event.target && event.target.closest ? event.target.closest('[data-share-menu], [data-share-result], [data-bwt="shareEnlargedPhoto"]') : null;
      if (!inside) closeShareMenus();
    }, true);
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeShareMenus(); });

    /* static buttons */
    buildFilters();
    renderCards();

    var cfSel = $('[data-bwt="colorFilter"]');
    if (cfSel) cfSel.addEventListener('change', function (event) { colorFilter = event.target.value; renderCards(); track('filter', null); });
    var clearCmp = $('[data-bwt="clearComparison"]');
    if (clearCmp) clearCmp.addEventListener('click', function () { comparedLooks = []; renderCards(); });
    var cmpClose = $('[data-bwt="comparisonClose"]');
    if (cmpClose) cmpClose.addEventListener('click', function () { if (compareDialogEl) hideDlg(compareDialogEl); });
    $('[data-bwt="lookPrevious"]').addEventListener('click', function () { var c = $('[data-bwt="lookCarousel"]'); c.scrollBy({ left: -c.clientWidth * 0.8, behavior: 'smooth' }); });
    $('[data-bwt="lookNext"]').addEventListener('click', function () { var c = $('[data-bwt="lookCarousel"]'); c.scrollBy({ left: c.clientWidth * 0.8, behavior: 'smooth' }); });

    $('[data-bwt="galleryClose"]').addEventListener('click', function () { hideDlg(galleryDialog); });
    $('[data-bwt="galleryTryOn"]').addEventListener('click', function () {
      var gLook = looks[galleryIndex];
      if (gLook && !tryOnAvailability(gLook).ok) {
        showToast('This combination is not available for try-on — try ' + (availableLengthsForColor(gLook.color).join(', ') || 'another color') + '.');
        return;
      }
      if (!remaining()) { showToast('You have used all 10 hairstyle Try-Ons today.'); return; }
      hideDlg(galleryDialog);
      openTryOn(galleryIndex);
    });
    $('[data-bwt="galleryTutorial"]').addEventListener('click', function () { openTutorial(galleryIndex); });

    $('[data-bwt="tryOnClose"]').addEventListener('click', tryToCloseTryOn);
    if (leaveDialog) {
      $('[data-bwt="closeTryOnAnyway"]').addEventListener('click', function () { hideDlg(leaveDialog); hideDlg(tryOnDialog); });
      $('[data-bwt="returnToTryOnPhotos"]').addEventListener('click', function () { hideDlg(leaveDialog); });
    }
    if (tryOnDialog) tryOnDialog.addEventListener('modal:afterHide', function () { clearTryOnTimers(); });
    $('[data-bwt="tryOnUpload"]').addEventListener('change', function (event) {
      var file = event.target.files && event.target.files[0];
      if (!file) return;
      if (submittingTryOn) { showToast('Your photo is being processed, please wait.'); return; }
      event.target.disabled = true;
      startGeneration(file);
      setTimeout(function () { event.target.disabled = false; }, 3000);
    });
    $('[data-bwt="chooseAnotherLook"]').addEventListener('click', function () {
      hideDlg(tryOnDialog);
    });
    $('[data-bwt="resultTutorialButton"]').addEventListener('click', function () { openTutorial(currentIndex); });

    $('[data-bwt="photoDialogClose"]').addEventListener('click', function () { hideDlg(photoDialog); });
    var dismissBtn = $('[data-bwt="dismissAiNotice"]');
    if (dismissBtn) dismissBtn.addEventListener('click', function () {
      aiNoticeDismissed = true;
      var notice = document.querySelector('.braided-wig-try-on-scope .ai-preview-notice');
      if (notice) notice.hidden = true;
    });
    $('[data-bwt="regenerateEnlargedPhoto"]').addEventListener('click', function (event) {
      var kind = enlargedResultKind;
      hideDlg(photoDialog);
      regenerateTryOnResult(kind, event.currentTarget);
    });
    $('[data-bwt="shareEnlargedPhoto"]').addEventListener('click', function (event) { toggleShareMenu('enlarged', event.currentTarget); });
    $('[data-bwt="downloadEnlargedPhoto"]').addEventListener('click', function (event) {
      var btn = event.currentTarget;
      var isPrimary = enlargedResultKind !== 'side';
      downloadUrl(resultSource(enlargedResultKind, isPrimary ? '[data-bwt="tryOnFrontResult"]' : '[data-bwt="tryOnSideResult"]'), resultFileName(enlargedResultKind), btn, 'Preview downloaded.');
    });

    $('[data-bwt="dialogClose"]').addEventListener('click', function () { hideDlg(tutorialDialog); });
    $('[data-bwt="mobileStepsButton"]').addEventListener('click', function () { var s = tutorialDialog.querySelector('.tutorial-shell'); if (s) s.classList.add('show-outline'); });
    $('[data-bwt="outlineClose"]').addEventListener('click', function () { var s = tutorialDialog.querySelector('.tutorial-shell'); if (s) s.classList.remove('show-outline'); });
    $('[data-bwt="previousStep"]').addEventListener('click', function () { moveTutorialVideo(-1); });
    $('[data-bwt="nextStep"]').addEventListener('click', function () { moveTutorialVideo(1); });
    $('[data-bwt="playButton"]').addEventListener('click', function (event) {
      var playing = event.currentTarget.getAttribute('aria-pressed') !== 'true';
      event.currentTarget.setAttribute('aria-pressed', String(playing));
      $('[data-bwt="videoStatus"]').textContent = playing ? 'Section preview' : 'Preview paused';
      renderTutorial();
    });

  }
  document.querySelectorAll('[data-braided-try-on]').forEach(initBraidedTryOn);
  /* global guard: hide any image that still fails to load (no variant + no product image) */
  document.addEventListener('error', function (event) {
    var el = event.target;
    if (el && el.tagName === 'IMG' && el.closest && el.closest('[data-braided-try-on]')) {
      el.style.display = 'none';
    }
  }, true);
})();
